<!-- Mentions légales (loi n° 2004-575 du 21 juin 2004, LCEN, art. 6).
     Les champs .todo-placeholder sont à remplir par l'association. -->
<template>
  <div>
    <Navbar />
    <div class="legal-page">
      <el-card shadow="always" class="legal-card">
        <template #header>
          <h1>Mentions légales</h1>
          <p class="legal-updated">Dernière mise à jour : 30 octobre 2026</p>
        </template>

        <h2>Éditeur du site</h2>
        <ul>
          <li>Nom : <span class="todo-placeholder">[À COMPLÉTER : nom de l'association]</span></li>
          <li>Forme juridique : association loi du 1<sup>er</sup> juillet 1901</li>
          <li>N° RNA / SIRET : <span class="todo-placeholder">[À COMPLÉTER : W… / SIRET]</span></li>
          <li>Siège social : <span class="todo-placeholder">[À COMPLÉTER : adresse postale]</span></li>
          <li>Directeur ou directrice de la publication : <span class="todo-placeholder">[À COMPLÉTER : prénom nom, qualité]</span></li>
          <li>Contact : <span class="todo-placeholder">[À COMPLÉTER : contact@domaine]</span></li>
        </ul>

        <h2>Hébergeur</h2>
        <p>
          OVH SAS, 2 rue Kellermann, 59100 Roubaix, France — RCS Lille Métropole 424 761 419 —
          téléphone : 1007 — <a href="https://www.ovhcloud.com" target="_blank" rel="noopener">www.ovhcloud.com</a>.
          Les données sont hébergées sur un serveur situé dans l'Union européenne.
        </p>

        <h2>Propriété intellectuelle</h2>
        <p>
          La structure du site, son nom, son logo et ses contenus éditoriaux sont la propriété de l'éditeur.
          Toute reproduction sans autorisation préalable est interdite.
          Les publications, commentaires et images partagés par les membres restent la propriété de leurs auteurs,
          qui en concèdent l'affichage sur Wedoomotion dans les conditions prévues par les
          <router-link to="/cgu">conditions générales d'utilisation</router-link>.
        </p>

        <h2>Contenus publiés par les membres</h2>
        <p>
          Les membres publient sans validation préalable. Tout contenu manifestement illicite peut être signalé
          avec le bouton « Signaler » présent sur chaque publication et chaque profil, ou à l'adresse de contact
          ci-dessus. L'équipe de modération le retire dans les meilleurs délais.
        </p>

        <h2>Données personnelles</h2>
        <p>
          Le traitement de vos données est décrit dans la
          <router-link to="/confidentialite">politique de confidentialité</router-link>.
        </p>

        <nav class="legal-links">
          <router-link to="/confidentialite">Politique de confidentialité</router-link>
          <router-link to="/cgu">Conditions générales d'utilisation</router-link>
        </nav>
      </el-card>
    </div>
  </div>
</template>

<script>
import '@/styles/legal.css'
import Navbar from '@/components/Navbar.vue'

export default {
  name: 'LegalNotice',
  components: {
    Navbar,
  },

  mounted() {
    document.body.style.backgroundColor = 'rgba(21, 109, 123)'
  },
}
</script>
